import React, { useState, useEffect } from 'react';
import {
  HeartPulse,
  Sparkles,
  Plane,
  Utensils,
  ArrowRight,
} from "lucide-react";
import BlogSection from './data';
import { Link } from "react-router-dom";
import Footer from './Footer';
import Faqs from './Faqs';
const IndustrySection = ({ name, icon, description, benefits, link }) => (
  <div className="bg-white p-6 rounded-lg shadow-md">
    <div className="flex items-center mb-4">
      {icon}
      <h2 className="text-2xl font-bold ml-4 text-[#075E54]">{name}</h2>
    </div>
    <p className="text-gray-700 mb-4">{description}</p>
    <ul className="list-disc list-inside mb-4">
      {benefits.map((benefit, index) => (
        <li key={index} className="text-gray-600">{benefit}</li>
      ))}
    </ul>
    <Link to={link} className="inline-flex items-center text-[#075E54] font-semibold hover:text-[#075E54]/80">
      Learn More <ArrowRight className="w-4 h-4 ml-2" />
    </Link>
  </div>
);

const ComparisonSection = () => (
  <div className="mt-12 bg-white p-6 rounded-lg shadow-md">
    <h2 className="text-2xl font-bold mb-4 text-[#075E54]">WhatsApp Business API vs. Regular WhatsApp</h2>
    <table className="w-full text-left">
      <thead>
        <tr>
          <th className="p-2">Feature</th>
          <th className="p-2">WhatsApp Business API</th>
          <th className="p-2">Regular WhatsApp</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="p-2">Automation</td>
          <td className="p-2">✅</td>
          <td className="p-2">❌</td>
        </tr>
        <tr>
          <td className="p-2">Multiple Users</td>
          <td className="p-2">✅</td>
          <td className="p-2">❌</td>
        </tr>
        <tr>
          <td className="p-2">CRM Integration</td>
          <td className="p-2">✅</td>
          <td className="p-2">❌</td>
        </tr>
        <tr>
          <td className="p-2">Broadcast Messages</td>
          <td className="p-2">✅</td>
          <td className="p-2">Limited</td>
        </tr>
      </tbody>
    </table>
  </div>
);


const industries = [
  {
    name: "Travel",
    icon: <Plane className="w-8 h-8 text-[#075E54]" />,
    description: "Transform your travel agency with WhatsApp Business Solutions. Engage customers, manage bookings, and provide instant support.",
    benefits: [
      "Send booking confirmations and updates",
      "Offer 24/7 customer support",
      "Share travel itineraries and documents",
      "Collect feedback and reviews"
    ],
    link: "/whatsapp-business-for-travel-and-tourism"
  },
  {
    name: "Beauty",
    icon: <Sparkles className="w-8 h-8 text-[#075E54]" />,
    description: "Elevate your beauty brand with personalized customer interactions. Showcase products, schedule appointments, and build loyalty.",
    benefits: [
      "Share product catalogs and promotions",
      "Book appointments and send reminders",
      "Provide beauty tips and tutorials",
      "Gather customer feedback and reviews"
    ],
    link: "/whatsapp-business-for-beauty-cosmetics-brands"
  },
  {
    name: "Health",
    icon: <HeartPulse className="w-8 h-8 text-[#075E54]" />,
    description: "Enhance patient care and streamline operations with WhatsApp Business Solutions for health and wellness businesses.",
    benefits: [
      "Send appointment reminders",
      "Share health tips and updates",
      "Provide telemedicine consultations",
      "Collect patient feedback"
    ],
    link: "/whatsapp-business-for-health-wellness-brands"
  },
  {
    name: "Food",
    icon: <Utensils className="w-8 h-8 text-[#075E54]" />,
    description: "Grow your restaurant or food business with WhatsApp. Take orders, send menus, and engage with customers seamlessly.",
    benefits: [
      "Accept orders via WhatsApp",
      "Send daily specials and promotions",
      "Provide delivery updates",
      "Gather customer reviews and feedback"
    ],
    link: "/whatsapp-business-for-restaurants-food-businesses"
  }
];

const faqs = [
  {
    question: "How can WhatsApp Business Solutions help my travel agency?",
    answer: "WhatsApp Business Solutions enable travel agencies to engage customers instantly, manage bookings efficiently, and provide real-time support, leading to higher customer satisfaction and increased bookings."
  },
  {
    question: "What are the benefits of using WhatsApp for customer support in the beauty industry?",
    answer: "In the beauty industry, WhatsApp allows for personalized interactions, easy appointment scheduling, and sharing of product information, enhancing customer loyalty and driving sales."
  },
  {
    question: "Can I use WhatsApp Business API for my health and wellness business?",
    answer: "Yes, WhatsApp Business API is ideal for health and wellness businesses to send appointment reminders, share health tips, and even conduct telemedicine consultations, improving patient care and operational efficiency."
  },
  {
    question: "How does WhatsApp help restaurants and food businesses?",
    answer: "Restaurants can use WhatsApp to accept orders, send menus and promotions, provide delivery updates, and gather customer feedback, streamlining operations and boosting customer engagement."
  }
];

const slides = [
  {
    industry: "Travel",
    title: "Grow Your Travel Agency Leads Using WhatsApp Effectively",
    description: "Launch click-to-WhatsApp ads featuring special travel offers to attract attention.Share WhatsApp links on social media and other platforms to boost visibility.Embed a WhatsApp widget on your website to start conversations instantly.",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_1.png"
  },
  {
    industry: "Beauty",
    title: "Elevate Your Beauty & Cosmetics Brand with WhatsApp",
    description: "Show off your products with a stunning WhatsApp storefront.Send exclusive offers to thousands of customers in a snap.Keep in touch 24/7 with smart WhatsApp automation.",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_1.png"
  },
  {
    industry: "Health",
    title: "Grow Your Health & Wellness Business with WhatsApp",
    description: "Recover lost sales with automated abandoned cart reminders.Share exciting deals and discounts through WhatsApp broadcasts.Display your wellness products beautifully in a WhatsApp catalog.",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_1.png"
  },
  {
    industry: "Food",
    title: "Grow Your Restaurant & Food Business with WhatsApp Magic",
    description: "Showcase your delicious menu using WhatsApp Catalogs.Let customers order and pay directly through WhatsApp for convenience.Provide 24/7 support to ensure every customer feels valued.",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_1.png"
  }
];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 pt-32">
        <h1 className="text-4xl font-bold text-center text-[#075E54] mb-8">WhatsApp Business Solutions for Your Industry</h1>
        
   

        <div className="relative overflow-hidden w-full  justify-center rounded-xl shadow-lg mb-12">
          <div 
            className="flex transition-transform duration-500 ease-in-out w-full"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div 
                key={index} 
                className="w-md flex-shrink-0 flex flex-col lg:flex-row items-center py-1  justify-center text-center lg:text-left relative min-w-full px-4 sm:px-6 rounded-xl bg-white shadow-md"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#075E54]/10 to-transparent"></div>
                <div className="w-full lg:w-4/5 flex justify-center z-10 mb-1 lg:mb-0">
                  <img
                    src={slide.image}
                    alt={`WhatsApp Business Solutions for ${slide.industry}`}
                    className="w-full max-w-md h-auto object-contain aspect-video  rounded-lg transition-transform duration-300 hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="w-full lg:w-3/5 max-w-2xl p-4 sm:p-6 md:p-8 z-10">
                  <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-900 font-bold leading-tight mb-3 md:mb-4">
                    {slide.title}
                  </h2>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed opacity-90">{slide.description}</p>
                </div>
              </div>
            ))}
          </div>
         
        </div>

        <div className="flex justify-center  mb-6">
            {slides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSlide(idx)}
                className={`w-2 h-2 rounded-full mx-1 transition-all duration-300 ${
                  currentSlide === idx ? 'bg-[#075E54] w-6' : 'bg-gray-300 hover:bg-[#075E54]'
                }`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:flex justify-center max-w-6xl mx-auto gap-3 sm:gap-4 md:gap-6 mb-6 md:mb-10">
          {industries.map((item, index) => (
            <Link key={index} to={item.link} className="w-full">
              <div className="flex items-center bg-white rounded-lg sm:rounded-xl px-4 py-3 sm:py-4 md:py-6 cursor-pointer group hover:bg-[#075E54] hover:text-white transition-all duration-300 shadow-sm hover:shadow-md">
                <div className="flex items-center space-x-2 sm:space-x-3">
                  {item.icon}
                  <span className="text-black text-sm sm:text-base font-medium group-hover:text-white transition-colors">{item.name}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>



        <BlogSection />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {industries.map((industry, index) => (
            <IndustrySection key={index} {...industry} />
          ))}
        </div>
        <ComparisonSection />
        

        <Faqs faqs={faqs} />
       

        
      </main>

      <title>WhatsApp Business Solutions for Travel, Beauty, Health & Food | ChatMitra</title>
      <meta name="description" content="Boost your business with WhatsApp Business Solutions for Travel, Beauty, Health, and Food. Enhance engagement, automate communication, and drive growth with ChatMitra." />
      <meta name="keywords" content="WhatsApp Business Solutions, Travel, Beauty, Health, Food, Customer Engagement, Automation, Lead Generation, ChatMitra" />
      <link rel="canonical" href="https://blog.chatmitra.com/" />
      <meta property="og:title" content="WhatsApp Business Solutions for Travel, Beauty, Health & Food | ChatMitra" />
      <meta property="og:description" content="Discover how WhatsApp Business Solutions can transform your business in Travel, Beauty, Health, and Food industries. Enhance customer engagement, automate communication, and drive growth with ChatMitra." />
      <meta property="og:url" content="https://blog.chatmitra.com/" />
      <meta property="og:type" content="website" />
      <Footer />
    </div>
  );
};

export default Home;





